import React from 'react';
import fr from 'facet-rest';
import KabobMenuItem from 'Views/Page/Content/Templates/WhatIfTemplate/Components/KabobMenu/KabobMenuItem';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import PropTypes from 'prop-types';

const VirtualAccountOutcomeConfigurationKabobMenuItem = React.forwardRef((props, ref) => {
  const { virtualAccountResource } = props;

  const { loadModalCollectionByLink } = useModalContext();

  if (!virtualAccountResource.relationship(fr.relationships.facetPlanVirtualAccountOutcomeConfigurationWizard.name)) {
    return null;
  }

  return (
    <KabobMenuItem
      ref={ref}
      label={'Outcome Earmarking'}
      onClick={() => {
        loadModalCollectionByLink(virtualAccountResource.relationship(fr.relationships.facetPlanVirtualAccountOutcomeConfigurationWizard.name).link('related').url());
      }}
    />
  );
});

VirtualAccountOutcomeConfigurationKabobMenuItem.defaultProps = {};

VirtualAccountOutcomeConfigurationKabobMenuItem.propTypes = {
  virtualAccountResource: PropTypes.object.isRequired,
};

export default VirtualAccountOutcomeConfigurationKabobMenuItem;
